import type { Phase, SlotCursor } from '@/workflow-builder/_contract/runtime';

export type FinalizeCurrentToolBindingsTransition =
    | { kind: 'finalize_draft' }
    | {
        kind: 'set_cursor';
        phase: Phase;
        activeSlotCursor: SlotCursor;
        requiresBranchDraft?: boolean;
    }
    | { kind: 'error_branch_editing' };

export function deriveFinalizeCurrentToolBindingsTransition(
    cursor: SlotCursor,
): FinalizeCurrentToolBindingsTransition {
    switch (cursor.cursorKind) {
        case 'self':
        case 'case/when':
        case 'branch/default/what':
            return { kind: 'finalize_draft' };
        case 'case/what':
            return {
                kind: 'set_cursor',
                phase: 'selecting_tool_at_slot',
                activeSlotCursor: { cursorKind: 'case/when' },
            };
        case 'cases/when':
            return {
                kind: 'set_cursor',
                phase: 'selecting_tool_at_slot',
                activeSlotCursor: {
                    cursorKind: 'cases/what',
                    caseIndex: cursor.caseIndex,
                },
            };
        case 'cases/what':
            return {
                kind: 'set_cursor',
                phase: 'reviewing_branch_cases',
                activeSlotCursor: { cursorKind: 'branch/editing' },
            };
        case 'branch/default/when':
            return {
                kind: 'set_cursor',
                phase: 'selecting_tool_at_slot',
                activeSlotCursor: {
                    cursorKind: 'branch/default/what',
                    caseIndex: cursor.caseIndex,
                },
                requiresBranchDraft: true,
            };
        case 'branch/editing':
            return { kind: 'error_branch_editing' };
    }
}

export type DiscardDraftTransition =
    | { kind: 'to_idle' }
    | { kind: 'loop_case_what' }
    | { kind: 'loop_case_when' }
    | { kind: 'branch_case_when'; caseIndex: number }
    | { kind: 'branch_case_what'; caseIndex: number }
    | { kind: 'branch_default_when' }
    | { kind: 'branch_default_what'; caseIndex: number };

export function deriveDiscardDraftTransition(cursor: SlotCursor): DiscardDraftTransition {
    switch (cursor.cursorKind) {
        case 'self':
        case 'branch/editing':
            return { kind: 'to_idle' };
        case 'case/what':
            return { kind: 'loop_case_what' };
        case 'case/when':
            return { kind: 'loop_case_when' };
        case 'cases/when':
            return { kind: 'branch_case_when', caseIndex: cursor.caseIndex };
        case 'cases/what':
            return { kind: 'branch_case_what', caseIndex: cursor.caseIndex };
        case 'branch/default/when':
            return { kind: 'branch_default_when' };
        case 'branch/default/what':
            return { kind: 'branch_default_what', caseIndex: cursor.caseIndex };
    }
}
